
import { Session, User as SupabaseUser } from '@supabase/supabase-js';
import { AuthAction, AuthState } from '@/types/auth';

// Updated initialState to use authError instead of error
export const initialState: AuthState = {
  user: null,
  profile: null,
  isLoading: true,
  isInitialized: false,
  authError: null
};

export const authReducer = (state: AuthState, action: AuthAction): AuthState => {
  switch (action.type) {
    case 'INITIALIZE':
      return {
        ...state,
        user: action.payload.user,
        profile: action.payload.profile,
        isLoading: false,
        authError: null,
        isInitialized: true
      };
    case 'SET_USER':
      return {
        ...state,
        user: action.payload,
        authError: null
      };
    case 'SET_PROFILE':
      return {
        ...state,
        profile: action.payload,
        authError: null
      };
    case 'SET_ERROR':
      return {
        ...state,
        authError: action.payload
      };
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.payload
      };
    case 'SET_INITIALIZED':
      return {
        ...state,
        isInitialized: true
      };
    case 'RESET':
      return {
        ...initialState,
        isInitialized: true,
        isLoading: false
      };
    default:
      return state;
  }
};
